document.addEventListener('turbolinks:load', () => {
  const snowItemScrollMenu = document.getElementById('snow-item-scroll-menu');
  if (!snowItemScrollMenu) { return; }

  const snowItemSection = document.getElementById('anchor-snow-items');
  const stayPackageSection = document.getElementById('anchor-stay-packages');
  const globalHeader = document.getElementsByClassName('global-header-wrapper')[0];

  const snowItemSectionY = snowItemSection.getBoundingClientRect().bottom;
  window.onscroll = () => {
    // 一定スクロールしたらメニューを固定する
    if (window.scrollY > snowItemSectionY) {
      snowItemScrollMenu.style = `position: fixed; top: ${globalHeader.clientHeight}px; left: 0;`;
    } else {
      snowItemScrollMenu.style = 'position: relative';
    };

    // activeタブを切り替える
    const snowItemTab = document.getElementById('snow-item-scroll-menu-item-snow-items');
    const stayPackageTab = document.getElementById('snow-item-scroll-menu-item-stay-packages');

    if (window.scrollY < stayPackageSection.getBoundingClientRect().bottom && !snowItemTab.classList.contains('active')) {
      snowItemTab.classList.add('active');
      stayPackageTab.classList.remove('active');
    } else if (window.scrollY >= stayPackageSection.getBoundingClientRect().bottom && !stayPackageTab.classList.contains('active')) {
      stayPackageTab.classList.add('active');
      snowItemTab.classList.remove('active');
    }
  };
});
